import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { User } from '../../../models/user.model';
import { AuthService } from '../../../services/auth.service';
import { UserRoleEnum } from '../../../enums/user-role-enum';
import {
  BsDatepickerModule,
  BsDatepickerConfig,
} from 'ngx-bootstrap/datepicker';
import moment from 'moment';
import { Country } from 'country-state-city';

import {
  FormBuilder,
  FormGroup,
  Validators,
  ReactiveFormsModule,
  ValidatorFn,
  ValidationErrors,
  FormControl,
  AbstractControl,
} from '@angular/forms';
declare var $: any;

@Component({
  selector: 'app-edit-user',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, BsDatepickerModule],
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.css',
})
export class EditUserComponent implements OnInit {
  countryCodes: Array<{ code: string; name: string; dial_code: string }> = [];
  defaultCountryCode = '+91';
  isDateSelected = false;
  loggedUser: User = new User();
  editUserForm: FormGroup;
  profileImangeName: any;
  userId: string = '';
  today: Date = new Date();
  fileError: string | null = null;
  selectedFile: File | null = null;
  email: any;
  authUser = localStorage.getItem('FLOCurrentUser');
  loginedUser = this.authUser ? JSON.parse(this.authUser) : '';
  datePickerConfig: Partial<BsDatepickerConfig> = {
    dateInputFormat: 'DD-MM-YYYY',
    maxDate: this.today,
  };
  noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      if (value.trim().length === 0) {
        return { whitespace: true };
      }
      return null;
    };
  }

  constructor(
    private authService: AuthService,
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    private readonly route: ActivatedRoute
  ) {
    this.editUserForm = this.fb.group({
      username: ['', [Validators.required, this.noWhitespaceValidator()]],
      email: new FormControl('', [
        (control: AbstractControl): ValidationErrors | null => {
          const emailPattern =
            /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
          const emailValid = emailPattern.test(control.value);
          return !emailValid ? { invalidEmail: true } : null;
        },
      ]),
      profileImage: ['', [Validators.required, this.imageFileValidator]],
      password: new FormControl('', [
        Validators.minLength(8),
        Validators.pattern(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/
        ),
      ]),
      firstName: ['', [Validators.required, this.noWhitespaceValidator()]],
      lastName: ['', [Validators.required, this.noWhitespaceValidator()]],
      dob: ['', [Validators.required]],
      gender: ['', Validators.required],
      phoneNumber: new FormControl(''),
      countryCode: ['', Validators.required],
      ConsumerPhone: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{10}$')],
      ],
      contactInfo: ['', Validators.required],
      profile_image_filename: [''],
      created_by: [''],
      project_id: [''],
      isPforileImageChange: [false],
    });
  }
  onDateSelected() {
    this.isDateSelected = true;
  }
  ngOnInit(): void {
    this.loadAllCountryCode();
    this.loggedUser = this.authService.CurrentUserValue;
    if (!this.loggedUser.project_id) {
      this.router.navigateByUrl(environment.DefaultRetrunUrlForMasterAdmin);
    } else if (this.loggedUser.role === UserRoleEnum.User) {
      this.router.navigateByUrl('/user/list');
    }
    this.getUserDetails();
  }
  oncancel = (): void => {
    this.router.navigateByUrl('/user/list');
  };
  loadAllCountryCode() {
    const countryData = Country.getAllCountries();
    this.countryCodes = countryData.map((country) => ({
      name: country.name,
      dial_code: country.phonecode,
      code: country.isoCode,
    }));
  }
  setDefaultCountryCode() {
    this.defaultCountryCode =
      this.countryCodes.find((country) => country.code === 'IN')?.dial_code ||
      '+91';

    this.editUserForm.patchValue({
      countryCode: this.defaultCountryCode,
    });
  }
  getUserDetails() {
    this.userId = this.route.snapshot.paramMap.get('id') || '';
    this.userService.getUser({ id: this.userId }).subscribe(
      (response: any) => {
        this.email = response.data.email;
        this.profileImangeName = response.data.profile_image_actual_filename;
        if (response.data.phone_no && response.data.phone_no.includes(',')) {
          const [countryCode, phoneNumber] = response.data.phone_no.split(',');
          this.editUserForm.patchValue({
            countryCode: countryCode,
            ConsumerPhone: phoneNumber,
          });
        } else {
          this.editUserForm.patchValue({
            countryCode: '',
            ConsumerPhone: response.data.phone_no,
          });
        }
        this.editUserForm.patchValue(
          {
            gender: response.data.gender
              ? response.data.gender.toLowerCase()
              : '',
          },
          { emitEvent: false }
        );
        this.editUserForm.patchValue({
          firstName: response.data.firstname,
          lastName: response.data.lastname,
          email: response.data.email,
          dob: response.data.dob ? response.data.dob : '',
          username: response.data.username,
          contactInfo: response.data.contact_info,
          profileImage: response.data.profile_image_actual_filename,
        });
        this.spinner.hide();
      },
      (err: any) => {
        this.spinner.hide();
        this.router.navigateByUrl('/user/list');
        this.toastr.error(err.error.Message, 'Edit User');
      }
    );
  }
  onSubmit(): void {
    if (this.editUserForm.invalid) {
      this.fileError = '';
      this.editUserForm.markAllAsTouched();
      return;
    } else {
      this.editUserForm.value.created_by = this.loggedUser?.id;
      let countryCode = this.editUserForm.get('countryCode')?.value;

      const consumerPhone = this.editUserForm.get('ConsumerPhone')?.value;
      const phoneNumber = countryCode + ',' + consumerPhone;
      const formData = new FormData();
      formData.append(
        'isPforileImageChange',
        this.editUserForm.get('isPforileImageChange')?.value
      );
      formData.append('project_id', this.loggedUser.project_id);
      formData.append('created_by', this.loginedUser.id);
      formData.append('id', this.userId);
      formData.append('username', this.editUserForm.get('username')?.value);
      formData.append('email', this.editUserForm.get('email')?.value);
      formData.append('firstName', this.editUserForm.get('firstName')?.value);
      formData.append('lastName', this.editUserForm.get('lastName')?.value);
      formData.append('dob', this.editUserForm.get('dob')?.value);
      formData.append('gender', this.editUserForm.get('gender')?.value);
      formData.append(
        'contactInfo',
        this.editUserForm.get('contactInfo')?.value
      );
      formData.append('phoneNumber', phoneNumber);

      const profileImage = this.editUserForm.get('profileImage')?.value;
      if (profileImage) {
        formData.append('profileImage', profileImage);
        formData.append('profile_image_filename', profileImage.name);
      }
      this.spinner.show();
      this.userService.updateAdmin(formData).subscribe(
        (response: any) => {
          this.spinner.hide();
          this.toastr.success(response.message, 'Edit User');

          this.router.navigateByUrl('/user/list');
        },
        (err: any) => {
          this.spinner.hide();
          this.toastr.error(err.error.error, 'Edit User', {
            timeOut: 5000,
          });
        }
      );
    }
  }

  // onFileChange(event: any): void {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

  //     if (!validImageTypes.includes(file.type)) {
  //       this.fileError = 'Please upload a valid image file (JPEG, PNG, GIF).';
  //     } else {
  //       this.selectedFile = file;

  //       this.editUserForm.patchValue({
  //         profile_image_filename: file.name,
  //         profileImage: file,
  //       });
  //       this.fileError = null;
  //     }
  //   }
  // }
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];

      if (!validImageTypes.includes(file.type)) {
        this.fileError = 'Please upload a valid image file (JPEG, PNG, GIF).';
        this.editUserForm.get('profileImage')?.setValue(null);
      } else {
        this.fileError = null;
        this.profileImangeName = file.name;
        this.editUserForm.get('profileImage')?.setValue(file);
        this.editUserForm.get('profile_image_filename')?.setValue(file.name);
        this.editUserForm.get('isPforileImageChange')?.setValue(true);
        const reader = new FileReader();
        reader.readAsDataURL(file);
      }
    }
  }

  getControl(controlName: string) {
    return this.editUserForm.get(controlName);
  }

  phoneNumberValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value || '';
      const phonePattern = /^[0-9]\d{10}$/;
      if (!phonePattern.test(value)) {
        return { invalidNumber: true };
      }

      return null;
    };
  }

  // createUser(): void {
  //   if (this.editUserForm.valid) {
  //     this.editUserForm.value.organisation_id = this.organisationId;
  //     this.editUserForm.value.created_by = this.loginedUser?.id;
  //     let body = {
  //       params: this.editUserForm.value,
  //     };
  //     this.spinner.show();
  //     this.userService.create(body).subscribe(
  //       (response: any) => {
  //         this.spinner.hide();
  //         this.toastr.success('User created successfully');

  //         this.routers.navigateByUrl('/user/list');
  //       },
  //       (err: any) => {
  //         this.spinner.hide();
  //         this.toastr.error(err.error.error, '', {
  //           timeOut: 5000,
  //         });
  //       }
  //     );
  //   } else {
  //     this.editUserForm.markAllAsTouched();
  //   }
  // }

  imageFileValidator() {
    return (control: any) => {
      const file = control.value;
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif'];
      if (file && file.type && !validImageTypes.includes(file.type)) {
        return { invalidFileType: true };
      }
      return null;
    };
  }
}
